import { THEME } from './utils.theme';

export const ErrorUtils = {
  translateError: (errorCode, theme?: string) => {
    const errorType = ErrorUtils.getErrorType(errorCode);
    return ErrorUtils.getErrorMessage(errorType || 'genericErrors', theme);
  },
  getErrorType: (errorCode) => {
    const errorCodes = ErrorUtils.getErrorCodes();
    const errorType = Object.keys(errorCodes).find((errorType) => errorCodes[errorType].includes(+errorCode));
    return errorType;
  },
  getErrorCodes: () => {
    return {
      historyErrors: [400050, 400051, 400052, 400053, 400054, 400055, 400056, 400057, 400058, 400059, 400091],
      contactErrors: [400080, 400081, 400083, 400085, 400092],
      emailErrors: [400082],
      phoneErrors: [400084],
      vehicleErrors: [
        400001, 400060, 400110, 400011, 400012, 400013, 400014, 400015, 400016, 400017, 400018, 400019, 400020, 400021, 400022, 400023, 400024, 400025, 400026, 400030,
      ],
      genericErrors: [400111, 400114, 400106, 400107, 400207, 500000, 404000, 400008, 400122],
      unsupportedUsageErrors: [400094],
      exceedOffersPerVIN: [400095],
      exceedOffersPerPhoneOrEmail: [400096, 400097],
      conditionErrors: [400061, 400062],
      offerErrors: [400100, 400101, 404103, 400105],
      offerAlreadyProcessedErrors: [400093],
      rvErrors: [
        400300, 400305, 400310, 400311, 400312, 400320, 400321, 400322, 400323, 400324, 400325, 400326, 400327, 400328, 400329, 400330, 400335, 400340, 400345, 400350, 400355,
        400360, 400365, 400370, 400371, 400372, 400373, 400374,
      ],
      dealerErrors: [400074, 400101, 400224, 400229, 400300, 400090, 403001, 403002, 403003, 403004],
      dealerRepErrors: [400227, 400228],
    };
  },
  getErrorMessage: (errorType, theme?: string) => {
    const errorMessages = {
      historyErrors: 'We found a problem with the Vehicle History Page. Please visit that page and check for errors.',
      contactErrors: 'We found a problem with the Contact Page. Please provide all required information and try again.',
      emailErrors: 'We found a problem with the Email Address. Please use the Contact Information edit link to update it.',
      phoneErrors: 'We found a problem with the Phone Number. Please use the Contact Information edit link to update it.',
      vehicleErrors: 'We found a problem with the Vehicle Details Page. Please visit that page and check for errors.',
      genericErrors: 'We found a problem processing your Offer. Please wait a moment, then try again.',
      conditionErrors: 'We found a problem with one of the Vehicle Condition Pages. Please visit those pages and check for errors.',
      offerErrors: 'We found a problem processing your Offer. Please wait a moment, then try again.',
      offerAlreadyProcessedErrors: 'This Offer was already processed. Please check your email for the details.',
      rvErrors: 'We found a problem with your Replacement Vehicle selection. Please check the information and try again.',
      dealerErrors: 'Please wait a minute and retry',
      dealerRepErrors: 'Please provide a valid sales representative.',
      unsupportedUsageErrors:
        "It looks like you've tried to create several different Instant Cash Offers. If you're having trouble, need assistance, or are interested in becoming a Participating Dealer, call 866-559-5268.",
      exceedOffersPerVIN: 'There is already an offer for this vehicle. Please contact the dealer to make any needed changes.',
      exceedOffersPerPhoneOrEmail: 'There are multiple ICO offers based on the information provided. Please contact the dealer to make any needed changes.',
    };
    const themedMessages = {
      [THEME.LUCID]: {
        exceedOffersPerPhoneOrEmail:
          "It looks like there's already an active trade-in pending for this vehicle. Please reach out to your sales advisor if you need to make any changes.",
      },
    };

    if (theme && themedMessages[theme] && themedMessages[theme][errorType]) {
      return themedMessages[theme][errorType];
    }

    return errorMessages[errorType];
  },
};
